import React from 'react';
import { HardDrive } from 'lucide-react';
import { Contenuto } from '../types';

// Incrocio Drive × Social (21/10/2026): drive.bymarke.com confronta le riprese caricate dal
// videomaker coi contenuti. «Presente nel Drive» = il contenuto è stato girato e le clip ci sono;
// «Recuperato dal Drive» = il contenuto non c'era ed è stato scritto dal parlato delle clip.
// La variante «grande» è per le card scure del Copywriter, «piccola» per le altre pagine.
export default function DriveFlagBadge({ contenuto, grande = false }: { contenuto: Contenuto; grande?: boolean }) {
  if (contenuto.driveFlag !== 'presente' && contenuto.driveFlag !== 'recuperato') return null;
  const recuperato = contenuto.driveFlag === 'recuperato';
  const titolo = recuperato
    ? `Recuperato dal Drive: non c'era in Social, testo trascritto dal parlato delle clip${contenuto.driveCartella ? ` (cartella «${contenuto.driveCartella}»)` : ''}`
    : `Presente nel Drive: le clip di questo contenuto sono state caricate${contenuto.driveCartella ? ` (cartella «${contenuto.driveCartella}»)` : ''}`;
  const etichetta = recuperato ? 'Recuperato dal Drive' : 'Presente nel Drive';
  if (grande) {
    return (
      <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] sm:text-xs font-semibold tracking-wide border ${
        recuperato ? 'bg-sky-500/15 text-sky-300 border-sky-500/30' : 'bg-teal-500/15 text-teal-300 border-teal-500/30'}`} title={titolo}>
        <HardDrive size={11} className="flex-shrink-0" />
        {etichetta}
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[10px] font-medium border ${
      recuperato ? 'bg-sky-100 dark:bg-sky-900/30 text-sky-700 dark:text-sky-300 border-sky-200 dark:border-sky-800'
                 : 'bg-teal-100 dark:bg-teal-900/30 text-teal-700 dark:text-teal-300 border-teal-200 dark:border-teal-800'}`} title={titolo}>
      <HardDrive size={10} className="flex-shrink-0" />
      {etichetta}
    </span>
  );
}
